var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from "react";
import { NavContext } from "./context";
import { initialConfig } from "./constants";
import { extractConfig } from "../../../lib/df";
var NavProvider = function (_a) {
    var _b = _a.environment, environment = _b === void 0 ? "production" : _b, children = _a.children;
    var _c = useState(__assign(__assign({}, initialConfig), { environment: environment })), params = _c[0], setParams = _c[1];
    useEffect(function () {
        var endpoint = environment === "development"
            ? initialConfig.endpoints.df.dev
            : environment === "staging"
                ? initialConfig.endpoints.df.stg
                : initialConfig.endpoints.df.prod;
        fetch(endpoint)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var headerConfig = extractConfig("header", data);
            var footerConfig = extractConfig("footer", data);
            var liveChatConfig = extractConfig("livechat", data);
            var entryModalConfig = extractConfig("entry_modal", data);
            setParams(function (params) { return (__assign(__assign({}, params), { hasFetchedConfig: true, config: {
                    header: headerConfig !== null && headerConfig !== void 0 ? headerConfig : initialConfig.config.header,
                    footer: footerConfig !== null && footerConfig !== void 0 ? footerConfig : initialConfig.config.footer,
                    liveChat: liveChatConfig !== null && liveChatConfig !== void 0 ? liveChatConfig : initialConfig.config.liveChat,
                    entryModal: entryModalConfig !== null && entryModalConfig !== void 0 ? entryModalConfig : initialConfig.config.entryModal,
                }, environment: environment })); });
        })
            .catch(function (e) {
            console.error("Failed to fetch nav config", e === null || e === void 0 ? void 0 : e.message);
        });
    }, [environment]);
    return React.createElement(NavContext.Provider, { value: params }, children);
};
export default NavProvider;
